import * as React from 'react';
import SpeechBubbleOutlined from './speech-bubble-outlined';
import SpeechBubbleFilled from './speech-bubble-filled';
import type { IconCombinedProps } from './types';
const SpeechBubbleCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <SpeechBubbleFilled ref={ref} {...rest} />;
  }
  return <SpeechBubbleOutlined ref={ref} {...rest} />;
});
export default SpeechBubbleCombined;